import customerInstance from '../../instance'

const createDeliveryConfigPolygon = (data) => {
  return customerInstance.post('/deliveryPolygonConfigs', data)
}

export default createDeliveryConfigPolygon
